<template>
  <div>
    <header class="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-md border-b border-border shadow-sm">
      <div class="container mx-auto px-4">
        <div class="flex items-center justify-between h-16">
          <!-- Logo -->
          <router-link to="/" class="flex-shrink-0">
            <Logo />
          </router-link>
          
          <!-- 主导航 -->
          <nav class="hidden lg:flex items-center gap-6 xl:gap-8">
            <router-link to="/" class="text-foreground hover:text-primary transition-colors text-sm xl:text-base">首页</router-link>
            <router-link to="/products" class="text-foreground hover:text-primary transition-colors text-sm xl:text-base">商品列表</router-link>
            <!-- 广告专区暂时隐藏 -->
            <!-- <router-link to="/marketplace" class="text-foreground hover:text-primary transition-colors text-sm xl:text-base">广告专区</router-link> -->
            <router-link to="/help" class="text-foreground hover:text-primary transition-colors text-sm xl:text-base">帮助中心</router-link>
            <button @click="isVerifyDialogOpen = true" class="text-foreground hover:text-primary transition-colors flex items-center gap-1 text-sm xl:text-base">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              客服验证
            </button>
            
            <!-- 关于我们下拉菜单 -->
            <div class="relative" ref="aboutMenuContainer">
              <button 
                @click="isAboutMenuOpen = !isAboutMenuOpen"
                class="text-foreground hover:text-primary transition-colors flex items-center gap-1 text-sm xl:text-base"
                :class="{ 'text-primary': isAboutMenuOpen }"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                关于我们
                <svg 
                  class="w-3 h-3 transition-transform" 
                  :class="{ 'rotate-180': isAboutMenuOpen }"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              
              <!-- 下拉面板 -->
              <transition name="fade-down">
                <div 
                  v-if="isAboutMenuOpen" 
                  class="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-100 py-2 z-50"
                >
                  <router-link 
                    to="/about/advantages" 
                    class="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors"
                    @click="isAboutMenuOpen = false"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>
                    </svg>
                    甜甜游戏服务网优势
                  </router-link>
                  <router-link 
                    to="/about/company" 
                    class="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors"
                    @click="isAboutMenuOpen = false"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                    </svg>
                    公司介绍
                  </router-link>
                  <router-link 
                    to="/about/business" 
                    class="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors"
                    @click="isAboutMenuOpen = false"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                    </svg>
                    业务介绍
                  </router-link>
                  <router-link 
                    to="/about/equipment" 
                    class="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors"
                    @click="isAboutMenuOpen = false"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                    </svg>
                    装备业务介绍
                  </router-link>
                </div>
              </transition>
            </div>
            
            <!-- 交易必看下拉菜单 -->
            <div class="relative" ref="tradeMenuContainer">
              <button 
                @click="isTradeMenuOpen = !isTradeMenuOpen"
                class="text-foreground hover:text-primary transition-colors flex items-center gap-1 text-sm xl:text-base"
                :class="{ 'text-primary': isTradeMenuOpen }"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
                交易必看
                <svg 
                  class="w-3 h-3 transition-transform" 
                  :class="{ 'rotate-180': isTradeMenuOpen }"
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              
              <!-- 下拉面板 -->
              <transition name="fade-down">
                <div 
                  v-if="isTradeMenuOpen" 
                  class="absolute top-full left-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-gray-100 py-2 z-50"
                >
                  <router-link 
                    to="/escrow-guarantee" 
                    class="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors"
                    @click="isTradeMenuOpen = false"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                    </svg>
                    中介担保
                  </router-link>
                  <router-link 
                    to="/service-agreement" 
                    class="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors"
                    @click="isTradeMenuOpen = false"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    服务协议
                  </router-link>
                  <router-link 
                    to="/after-sales" 
                    class="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors"
                    @click="isTradeMenuOpen = false"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"/>
                    </svg>
                    售后服务
                  </router-link>
                </div>
              </transition>
            </div>
          </nav>
          
          <!-- 搜索和用户操作 -->
          <div class="flex items-center gap-2 md:gap-4">
            <!-- 搜索框 -->
            <div class="hidden md:flex items-center gap-2 bg-input-background px-3 xl:px-4 py-2 rounded-full w-40 xl:w-64 relative" ref="searchContainer">
              <svg class="w-[18px] h-[18px] text-muted-foreground flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.35-4.35"/>
              </svg>
              <input 
                type="text" 
                placeholder="请输入商品编号或标题属性关键字" 
                class="bg-transparent outline-none w-full text-sm"
                v-model="searchQuery"
                @focus="showSearchHistory = true"
                @keyup.enter="handleSearch"
              />
              <!-- 快速清空按钮 -->
              <button 
                v-if="searchQuery"
                @click="clearSearch"
                class="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
                title="清空"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </button>
              
              <!-- 历史搜索下拉面板 -->
              <div v-if="showSearchHistory" class="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-lg border border-gray-100 p-4 z-50" style="min-width: 320px;">
                <!-- 历史搜索 -->
                <div v-if="searchHistory.length > 0" class="mb-4">
                  <div class="flex items-center justify-between mb-3">
                    <span class="text-sm font-bold text-gray-800">历史搜索</span>
                    <button @click="clearHistory" class="text-gray-400 hover:text-gray-600 transition-colors">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                  <div class="flex flex-wrap gap-2">
                    <button 
                      v-for="(item, index) in searchHistory" 
                      :key="index"
                      @click="quickSearch(item)"
                      class="px-3 py-1.5 bg-gray-50 hover:bg-gray-100 text-gray-600 text-xs rounded-lg transition-colors"
                    >
                      {{ item }}
                    </button>
                  </div>
                </div>
                
                <!-- 猜你想搜 -->
                <div>
                  <div class="flex items-center gap-2 mb-3">
                    <svg class="w-4 h-4 text-orange-500" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                    <span class="text-sm font-bold text-gray-800">猜你想搜</span>
                  </div>
                  <div class="flex flex-wrap gap-2">
                    <button 
                      v-for="(item, index) in hotSearches" 
                      :key="index"
                      @click="quickSearch(item)"
                      class="px-3 py-1.5 bg-orange-50 hover:bg-orange-100 text-orange-600 text-xs rounded-lg transition-colors"
                    >
                      {{ item }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 发布商品按钮 -->
            <router-link v-if="isLoggedIn" to="/publish/product" class="px-3 md:px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white rounded-full transition-all text-xs md:text-sm flex items-center gap-1">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
              <span class="hidden sm:inline">发布</span>
            </router-link>
            
            <!-- 用户 -->
            <router-link 
              v-if="isLoggedIn"
              to="/profile"
              class="flex items-center gap-2 px-3 xl:px-4 py-2 bg-gradient-to-r from-primary to-secondary text-white rounded-full hover:opacity-90 transition-opacity text-xs md:text-sm"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span class="hidden sm:inline">个人中心</span>
            </router-link>
            <router-link 
              v-else
              to="/login"
              class="flex items-center gap-2 px-3 xl:px-4 py-2 bg-gradient-to-r from-primary to-secondary text-white rounded-full hover:opacity-90 transition-opacity text-xs md:text-sm"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span class="hidden sm:inline">登录</span>
            </router-link>
            
            <!-- 移动端菜单按钮 -->
            <button class="lg:hidden p-2" @click="isMobileMenuOpen = !isMobileMenuOpen">
              <svg v-if="isMobileMenuOpen" class="w-6 h-6 text-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
              <svg v-else class="w-6 h-6 text-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <line x1="3" y1="12" x2="21" y2="12"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <line x1="3" y1="18" x2="21" y2="18"/>
              </svg>
            </button>
          </div>
        </div>
        
        <!-- 移动端菜单展开内容 -->
        <div v-if="isMobileMenuOpen" class="lg:hidden pb-4 border-t border-border mt-2 pt-4">
          <nav class="flex flex-col space-y-3">
            <router-link to="/" class="text-foreground hover:text-primary transition-colors py-2 px-4 hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
              首页
            </router-link>
            <router-link to="/products" class="text-foreground hover:text-primary transition-colors py-2 px-4 hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
              商品列表
            </router-link>
            <!-- 广告专区暂时隐藏 -->
            <!-- <router-link to="/marketplace" class="text-foreground hover:text-primary transition-colors py-2 px-4 hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
              广告专区
            </router-link> -->
            <router-link to="/help" class="text-foreground hover:text-primary transition-colors py-2 px-4 hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
              帮助中心
            </router-link>
            <button @click="openVerifyDialog" class="text-foreground hover:text-primary transition-colors flex items-center gap-2 py-2 px-4 hover:bg-pink-50 rounded-lg text-left">
              <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              客服验证
            </button>
            
            <!-- 关于我们子菜单 -->
            <div class="px-4 py-2">
              <div class="text-foreground font-medium mb-2 flex items-center gap-2">
                <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                关于我们
              </div>
              <div class="pl-6 space-y-1">
                <router-link to="/about/advantages" class="block py-2 px-4 text-gray-600 hover:text-primary hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
                  甜甜游戏服务网优势
                </router-link>
                <router-link to="/about/company" class="block py-2 px-4 text-gray-600 hover:text-primary hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
                  公司介绍
                </router-link>
                <router-link to="/about/business" class="block py-2 px-4 text-gray-600 hover:text-primary hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
                  业务介绍
                </router-link>
                <router-link to="/about/equipment" class="block py-2 px-4 text-gray-600 hover:text-primary hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
                  装备业务介绍
                </router-link>
              </div>
            </div>
            
            <!-- 交易必看子菜单 -->
            <div class="px-4 py-2">
              <div class="text-foreground font-medium mb-2 flex items-center gap-2">
                <svg class="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
                交易必看
              </div>
              <div class="pl-6 space-y-1">
                <router-link to="/escrow-guarantee" class="block py-2 px-4 text-gray-600 hover:text-primary hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
                  中介担保
                </router-link>
                <router-link to="/service-agreement" class="block py-2 px-4 text-gray-600 hover:text-primary hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
                  服务协议
                </router-link>
                <router-link to="/after-sales" class="block py-2 px-4 text-gray-600 hover:text-primary hover:bg-pink-50 rounded-lg" @click="isMobileMenuOpen = false">
                  售后服务
                </router-link>
              </div>
            </div>
            
            <!-- 移动端搜索框 -->
            <div class="flex items-center gap-2 bg-input-background px-4 py-2 rounded-lg mx-4">
              <svg class="w-[18px] h-[18px] text-muted-foreground flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.35-4.35"/>
              </svg>
              <input 
                type="text" 
                placeholder="搜索..." 
                class="bg-transparent outline-none w-full text-sm"
              />
            </div>
          </nav>
        </div>
      </div>
    </header>

    <CustomerServiceVerifyDialog :is-open="isVerifyDialogOpen" @close="isVerifyDialogOpen = false" />
  </div>
</template>

<style scoped>
/* 下拉菜单动画 */
.fade-down-enter-active,
.fade-down-leave-active {
  transition: all 0.2s ease;
}
.fade-down-enter,
.fade-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo.vue'
import CustomerServiceVerifyDialog from './CustomerServiceVerifyDialog.vue'

export default {
  name: 'Navbar',
  components: {
    Logo,
    CustomerServiceVerifyDialog
  },
  data() {
    return {
      isVerifyDialogOpen: false,
      isMobileMenuOpen: false,
      isTradeMenuOpen: false,
      isAboutMenuOpen: false,
      searchQuery: '',
      showSearchHistory: false,
      searchHistory: [],
      hotSearches: ['QQ三国', '高等级账号', '元神', '奥义', '游戏币', '装备', '子女']
    }
  },
  mounted() {
    // 从localStorage加载搜索历史
    const saved = localStorage.getItem('searchHistory')
    if (saved) {
      this.searchHistory = JSON.parse(saved)
    }
    // 点击外部关闭搜索历史
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn', 'nickname', 'avatar'])
  },
  methods: {
    openVerifyDialog() {
      this.isVerifyDialogOpen = true
      this.isMobileMenuOpen = false
    },
    clearSearch() {
      this.searchQuery = ''
    },
    handleSearch() {
      if (this.searchQuery.trim()) {
        const keyword = this.searchQuery.trim()
        // 检查是否与当前查询相同，避免重复导航
        if (this.$route.path === '/products' && this.$route.query.keyword === keyword) {
          this.showSearchHistory = false
          return
        }
        // 添加到历史记录
        this.addToHistory(keyword)
        // 跳转到搜索页面，使用keyword参数与商品列表筛选接口一致
        const query = { keyword: keyword }
        if (this.$route.path === '/products') {
          this.$router.replace({ path: '/products', query }).catch(() => {})
        } else {
          this.$router.push({ path: '/products', query })
        }
        this.showSearchHistory = false
      }
    },
    quickSearch(keyword) {
      // 检查是否与当前查询相同，避免重复导航
      if (this.$route.path === '/products' && this.$route.query.keyword === keyword) {
        this.showSearchHistory = false
        return
      }
      this.searchQuery = keyword
      this.addToHistory(keyword)
      const query = { keyword: keyword }
      if (this.$route.path === '/products') {
        this.$router.replace({ path: '/products', query }).catch(() => {})
      } else {
        this.$router.push({ path: '/products', query })
      }
      this.showSearchHistory = false
    },
    addToHistory(keyword) {
      // 去重并限制数量
      this.searchHistory = this.searchHistory.filter(item => item !== keyword)
      this.searchHistory.unshift(keyword)
      if (this.searchHistory.length > 10) {
        this.searchHistory = this.searchHistory.slice(0, 10)
      }
      // 保存到localStorage
      localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory))
    },
    clearHistory() {
      this.searchHistory = []
      localStorage.removeItem('searchHistory')
    },
    handleClickOutside(event) {
      if (this.$refs.searchContainer && !this.$refs.searchContainer.contains(event.target)) {
        this.showSearchHistory = false
      }
      if (this.$refs.tradeMenuContainer && !this.$refs.tradeMenuContainer.contains(event.target)) {
        this.isTradeMenuOpen = false
      }
      if (this.$refs.aboutMenuContainer && !this.$refs.aboutMenuContainer.contains(event.target)) {
        this.isAboutMenuOpen = false
      }
    }
  }
}
</script>
